import React, { FC } from 'react'
import { Box, Grid } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { LoadRecommendation } from 'apps/fleet-planner/types'
import { ViewMoreLikeThisHistoricalLanesButton } from '../../ViewMoreLikeThisHistoricalLanesButton'
import ShipmentCard, { getRecommendedShipment } from '../../shipment/ShipmentCard'
import { IRecommendedShipmentFragment } from '../../shipment/ShipmentCard/graphql/RecommendedShipmentFragment'
import { BookableShipmentSearchRunItAgainBookLane } from './BookableShipmentSearchRunItAgainBookLane'

interface IBookableShipmentSearchRunItAgainBookContainerRowProps {
  loadRecommendation: LoadRecommendation
}

export const BookableShipmentSearchRunItAgainBookContainerRow: FC<IBookableShipmentSearchRunItAgainBookContainerRowProps> = ({
  loadRecommendation,
}) => {
  const { recommendations: loadRecommendations = [] } = loadRecommendation || {}
  const { isMobile } = useBreakpointContext()

  const recommendations: IRecommendedShipmentFragment[] = loadRecommendations.map(rec =>
    getRecommendedShipment(rec)
  )

  return (
    <Box py={isMobile ? 0 : 2}>
      {isMobile ? (
        <div>
          <BookableShipmentSearchRunItAgainBookLane loadRecommendation={loadRecommendation} />
          <Box py={2}>
            <Grid container spacing={4}>
              {recommendations.map(recommendation => {
                const { shipmentId: loadRecommendationId } = recommendation || {}
                return (
                  <Grid key={loadRecommendationId} item md={4} xs={12}>
                    <ShipmentCard
                      variant='book'
                      dataTest={`recommendation-tile-${loadRecommendationId}`}
                      recommendation={recommendation}
                    />
                  </Grid>
                )
              })}
            </Grid>
          </Box>
          <ViewMoreLikeThisHistoricalLanesButton loadRecommendation={loadRecommendation} />
        </div>
      ) : (
        <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between'>
          <Grid container md={3}>
            <Grid item md={12}>
              <BookableShipmentSearchRunItAgainBookLane loadRecommendation={loadRecommendation} />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            {recommendations.map(recommendation => {
              const { shipmentId: loadRecommendationId } = recommendation || {}
              return (
                <Grid key={loadRecommendationId} item md={4} xs={12}>
                  <ShipmentCard
                    variant='book'
                    dataTest={`recommendation-tile-${loadRecommendationId}`}
                    recommendation={recommendation}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Box>
      )}
    </Box>
  )
}
